ACC.utility = {
  _autoload: ['removeExtraTag'],

  removeExtraTag: function(data) {
    var findTagRegexp = {
      scriptTag: /<script[\s\S]*?>[\s\S]*?<\/script>/g,
      headTag: /<head[\s\S]*?>[\s\S]*?<\/head>/g
    };

    for (var key in findTagRegexp) {
      if (findTagRegexp.hasOwnProperty(key)) {
        if (findTagRegexp[key].test(data)) {
          data = data.replace(findTagRegexp[key], '');
        }
      }
    }
    return data;
  },

  setEllipsis: function(htmlElement) {
    var wordArray;
    $.each(htmlElement, function(index) {
      wordArray = $(this)
        .text()
        .split(' ');
      while ($(this).prop('scrollHeight') > $(this).prop('offsetHeight')) {
        if (wordArray.length === 0) return;
        wordArray.pop();
        $(this).text(wordArray.join(' ') + '...');
      }
    });
  },

  setDropdownHeight: function(event) {
    var $htmlElement = $(this);
    var selectId = $htmlElement.attr('id').replace('-button', '');
    var dropdownLength = $('#' + selectId).children('option').length;
    var $selectMenuId = $('#' + selectId + '-menu');
    var panelHeight = 0;

    $.each($selectMenuId.find('.ui-menu-item'), function(index) {
      if (
        $(this)
          .find('.ui-menu-item-wrapper')
          .text()
          .trim() === ''
      ) {
        $(this).css('display', 'none');
      }
    });
    if (dropdownLength <= 6) {
      $selectMenuId.parents('.ui-selectmenu-menu').css({
        height: 'auto',
        overflow: 'hidden auto'
      });
    } else if (dropdownLength > 6 && dropdownLength <= 15) {
      $selectMenuId.find('.ui-menu-item').each(function(index) {
        if (index < 4) {
          panelHeight = panelHeight + $(this).height();
        }
      });
      $selectMenuId.parents('.ui-selectmenu-menu').css({
        height: panelHeight + 'px',
        overflow: 'hidden scroll'
      });
    } else if (dropdownLength > 15) {
      $selectMenuId.find('.ui-menu-item').each(function(index) {
        if (index < 6) {
          panelHeight = panelHeight + $(this).height();
        }
      });
      $selectMenuId.parents('.ui-selectmenu-menu').css({
        height: panelHeight + 'px',
        overflow: 'hidden scroll'
      });
    }
  },
  
  formatDateInputField:function(e) {
    var separator = '/';
    var textSoFar = $(this).val();
    if (e.keyCode != 191) {
      if (e.keyCode != 8) {
        if (textSoFar.length == 2 || textSoFar.length == 5) {
          $(this).val(textSoFar + separator);
        } else if (e.keyCode == 86 && textSoFar.length == 8) {
          $(this).val(
            textSoFar.substr(0, 2) +
              separator +
              textSoFar.substr(2, 2) +
              separator +
              textSoFar.substr(4, 4)
          );
        }
      } else {
        //backspace would skip the slashes and just remove the numbers
        if (textSoFar.length == 5) {
          $(this).val(textSoFar.substring(0, 4));
        } else if (textSoFar.length == 2) {
          $(this).val(textSoFar.substring(0, 1));
        }
      }
    } else {
      $(this).val(textSoFar.substring(0, textSoFar.length - 1));
    }
  }
};
